import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import SelectField from "../../../../shared/components/fields/selectField/SelectField";
import {I18n} from 'react-redux-i18n';
import moment from 'moment';
import IconButton from "../../../../shared/components/others/IconButton";
import addButton from "../../../../shared/img/add-widget-button.svg";
import SwitchField from "../../../../shared/components/fields/switchField/SwitchField";
import _ from "../../../../shared/utils/ObjectUtils";
import TextField from "../../../../shared/components/fields/textField/TextField";
import arrowDown from "../../../../shared/img/arrow-down.svg";
import deleteButton from "../../../../shared/img/delete-button-chart-form.svg";
import SeriesLinesInterfacesConfigField from "./SeriesLinesInterfacesConfigField";
import duplicateButton from "../../../../shared/img/duplicate-button.svg";

const ExpansionPanel = withStyles({
    root: {
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
        border: "1px solid #e3e3e3",
        borderRadius: "10px !important",
        boxShadow: "0 0 10px 0 rgba(155, 155, 155, 0.3)",
    },
    expanded: {},
})(MuiExpansionPanel);
const ExpansionPanelSummary = withStyles({
    root: {
        minHeight: 56,
        margin: '0 2rem 0 2rem',
        padding: 0
    },
    expanded: {},
    expandIcon: {}
})(MuiExpansionPanelSummary);
const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: '16px 0 0 0',
        width: "100%"
    },
}))(MuiExpansionPanelDetails);

const SeriesLinesConfigField =
    ({
         seriesElem,
         seriesIndex,
         interfaceCategoryList,
         unitList,

         entityList,
         terminalsListByEntityId,
         interfacesListByEntityId,
         interfacesListByTerminalId,
         handleEntityChangeInSeries,

         handleTerminalChangeInSeries,
         handleInterfaceChangeInSeries,
         handleAddInterfaceToSeriesLineClicked,
         handleDeleteInterfaceOfSeriesLineClicked,
         handleSeriesFieldChange, //(seriesIndex, fieldKey, value) => "type" and "window range"
         handleAddLineToSeriesButtonClicked, //add line to series
         handleDeleteLineOfSeriesClicked,
         handleDuplicateLineOfSeriesClicked,
         handleLineFieldChange
     }) => {

        const [expandedArray, setExpanded] = React.useState(["series_" + seriesIndex + "_line_0"]);

        const handleChange = panel => (event, isExpanded) => {
            if(isExpanded) {
                setExpanded([
                    ...expandedArray,
                    panel
                ]);
            } else {
                setExpanded(expandedArray.filter( v => v !== panel));
            }
        };

        return (
            <div className="series-element-form">
                <div className="row series-element-fields"> {/*Series' Type and Window Range*/}
                    {/*Type*/}
                    <SelectField
                        themeName="form"
                        label={I18n.t("dashboard.widgets.formsFields.chartSeries.type.label")}
                        value={seriesElem.type}
                        handleFieldChange={value => handleSeriesFieldChange(seriesIndex, "type", value)}
                        options={getSeriesTypeOptions()}
                        width={5}
                    />
                    {/*Window Range*/}
                    <SelectField
                        themeName="form"
                        label={I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.label")}
                        value={seriesElem.windowRange}
                        handleFieldChange={value => handleSeriesFieldChange(seriesIndex, "windowRange", value)}
                        options={getWindowRangeOptions()}
                        width={5}
                    />
                </div>

                <div className="series-element-lines-wrapper"> {/*Lines Wrapper*/}
                    {
                        seriesElem.lines.map((lineElem, lineIndex) => {

                            const key = "series_" + seriesIndex + "_line_" + lineIndex;

                            return (
                                <div key={key} className="series-element-line-element">
                                    <ExpansionPanel expanded={expandedArray.indexOf(key) !== -1 } onChange={handleChange(key)}>
                                        <ExpansionPanelSummary
                                            id={key + "d-header"}
                                            aria-controls={key + "d-content"}
                                            expandIcon={
                                                <IconButton
                                                    alt="arrowDown"
                                                    image={arrowDown}
                                                    handleIconClick={() => handleChange(key)}
                                                />
                                            }
                                        >
                                            <div className="line-title">
                                                <b>{ lineElem.legend ? lineElem.legend : I18n.t('dashboard.widgets.formsFields.chartSeries.labels.line') + " " + (lineIndex+1)}</b>
                                                <div className="line-title-action-icons">
                                                    <IconButton
                                                        alt="duplicate"
                                                        classes={"line-title-action-icon-duplicate"}
                                                        image={duplicateButton}
                                                        handleIconClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDuplicateLineOfSeriesClicked(seriesIndex, lineIndex)
                                                        }}
                                                    />
                                                    <div style={{opacity: (seriesElem.lines.length <= 1) ? '0.5' : '1'}}>
                                                        <IconButton
                                                            alt="delete"
                                                            disabled={seriesElem.lines.length <= 1}
                                                            image={deleteButton}
                                                            handleIconClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteLineOfSeriesClicked(seriesIndex, lineIndex)
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                            <div  className="series-element-line-fields-wrapper">
                                                <div className="series-element-line-fields"> {/*Lines Fields*/}
                                                    <div className="row series-line-field-row">
                                                        {/*Legend*/}
                                                        <TextField
                                                            themeName="form"
                                                            value={lineElem.legend}
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.legend")}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'legend', value)}
                                                            width={5}
                                                        />
                                                        {/*Resolution Aggregator*/}
                                                        <SelectField
                                                            themeName="form"
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.label")}
                                                            value={lineElem.resolutionAggregator}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'resolutionAggregator', value)}
                                                            options={getResolutionAggregator()}
                                                            width={5}
                                                        />
                                                    </div>
                                                    <div className="row series-line-field-row">
                                                        {/*Resolution*/}
                                                        <SelectField
                                                            themeName="form"
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.label")}
                                                            value={lineElem.resolution}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'resolution', value)}
                                                            options={getResolutionOptionsForWindowRange(seriesElem.windowRange)}
                                                            width={5}
                                                        />
                                                        {/*Cumulative Series*/}
                                                        <SwitchField
                                                            themeName="form"
                                                            checked={!_.isNilOrEmpty(lineElem.cumulativeSeries) ? lineElem.cumulativeSeries : false}
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.cumulativeSeries")}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'cumulativeSeries', value)}
                                                            width={5}
                                                        />
                                                    </div>
                                                    <div className="row series-line-field-row">
                                                        {/*Interface Category*/}
                                                        <SelectField
                                                            themeName="form"
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.interfaceCategory")}
                                                            value={lineElem.interfaceCategory}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'interfaceCategory', value)}
                                                            options={interfaceCategoryList}
                                                            width={5}
                                                        />
                                                        <SelectField
                                                            themeName="form"
                                                            label={I18n.t("dashboard.widgets.formsFields.chartSeries.unit")}
                                                            value={lineElem.unit}
                                                            handleFieldChange={value => handleLineFieldChange(seriesIndex, lineIndex, 'unit', value)}
                                                            options={unitList}
                                                            width={5}
                                                        />
                                                    </div>
                                                </div>
                                                <SeriesLinesInterfacesConfigField
                                                    lineElem={lineElem}
                                                    seriesIndex={seriesIndex}
                                                    lineIndex={lineIndex}
                                                    entityList={entityList}
                                                    terminalsListByEntityId={terminalsListByEntityId}
                                                    interfacesListByEntityId={interfacesListByEntityId}
                                                    interfacesListByTerminalId={interfacesListByTerminalId}

                                                    categorySelected={lineElem.interfaceCategory}
                                                    resolutionAggregator={lineElem.resolutionAggregator}

                                                    handleEntityChangeInSeries={handleEntityChangeInSeries}
                                                    handleTerminalChangeInSeries={handleTerminalChangeInSeries}
                                                    handleInterfaceChangeInSeries={handleInterfaceChangeInSeries}
                                                    handleAddInterfaceToSeriesLineClicked={handleAddInterfaceToSeriesLineClicked}
                                                    handleDeleteInterfaceOfSeriesLineClicked={handleDeleteInterfaceOfSeriesLineClicked}
                                                />
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </div>
                            )})
                    }
                </div>

                {/*Add Line Button*/}
                <div className="add-series-button" onClick={() => handleAddLineToSeriesButtonClicked(seriesIndex)}>
                    <IconButton
                        alt="addLine"
                        selected={false}
                        image={addButton}
                        classes="mr-2"
                    />
                    <b>{I18n.t('dashboard.widgets.formsFields.chartSeries.labels.addLine')}</b>
                </div>
            </div>
        );
    };


const getSeriesTypeOptions = () => ([
    {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.type.line"),
        value: 'line'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.type.column"),
        value: 'column'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.type.step"),
        value: 'step'
    }
]);

const getWindowRangeOptions = () => ([
    {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.oneHour"),
        value: moment.duration(1, "h").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.twoHours"),
        value: moment.duration(2, "h").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.sixHours"),
        value: moment.duration(6, "h").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.twelveHours"),
        value: moment.duration(12, "h").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.twentyFourHours"),
        value: moment.duration(24, "h").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.twoDays"),
        value: moment.duration(2, "d").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.oneWeek"),
        value: moment.duration(1, "w").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.twoWeeks"),
        value: moment.duration(2, "w").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.oneMonth"),
        value: moment.duration(31, "d").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.sixMonths"),
        value: moment.duration(186, "d").asMilliseconds()
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.windowRange.oneYear"),
        value: moment.duration(365, "d").asMilliseconds()
    }
]);

const getResolutionAggregator = () => ([
    {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.avg"),
        value: 'AVG'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.min"),
        value: 'MIN'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.max"),
        value: 'MAX'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.sum"),
        value: 'SUM'
    }, {
        label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolutionAgg.allValues"),
        value: 'ALL_VALUES'
    }
]);

const getResolutionOptionsForWindowRange = windowRange => {
    if (_.isNilOrEmpty(windowRange))
        return [];

    let data = [];

    if (windowRange <= moment.duration(24, "h").asMilliseconds()) {
        data.push({
            value: '5m',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.fiveMinutes"),
        });
    }

    if (windowRange <= moment.duration(1, "w").asMilliseconds()) {
        data.push({
            value: '15m',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.fifteenMinutes"),
        });
    }

    if (windowRange > moment.duration(12, "h").asMilliseconds() && windowRange <= moment.duration(31, "d").asMilliseconds()) {
        data.push({
            value: '1h',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.oneHour"),
        });
    }

    if (windowRange >= moment.duration(1, "w").asMilliseconds()) {
        data.push({
            value: '1d',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.oneDay"),
        });
    }

    if (windowRange >= moment.duration(31, "d").asMilliseconds()) {
        data.push({
            value: '1w',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.oneWeek"),
        });
    }

    if (windowRange >= moment.duration(186, "d").asMilliseconds()) {
        data.push({
            value: '1M',
            label: I18n.t("dashboard.widgets.formsFields.chartSeries.resolution.oneMonth"),
        });
    }

    return data;
};


export default SeriesLinesConfigField;